<template>
    <div class="wedding">
        <z-title title="婚庆提成" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac">
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    placeholder="输入新郎或新娘姓名"
                    maxlength="8"
                    clearable
                    title="输入新郎或新娘姓名"
                    prefix-icon="el-icon-search"
                    v-model="maleFemaleName">
            </el-input>
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    type="number"
                    placeholder="输入电话号码"
                    clearable
                    title="输入电话号码"
                    prefix-icon="el-icon-search"
                    maxlength="11"
                    v-model="maleFemalePhone">
            </el-input>

                <div class="textnowrap">典礼日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="dateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
         </div>
            <div class="flex-n fac mt-10">

                <div class="textnowrap">下单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="orderDateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                <el-button type="primary" class="ele-btn2" @click="searchWeddingOrder">查询</el-button>

            </div>
        </el-card>
        <!--列表-->
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="maleName"
                        label="新郎姓名"
                        width="100">
                </el-table-column>
                <el-table-column
                        fixed
                        align="center"
                        prop="femaleName"
                        label="新娘姓名"
                        width="100">
                </el-table-column>
                <el-table-column
                        label="订单状态"
                        min-width="100"
                        align="center">
                    <template slot-scope="scope">
                        <template v-for="item,index in confirmStateList" v-if="item.dicCode==scope.row.confirmState">
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='04'" type="warning">
                                {{item.dicName}}
                            </el-tag>
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='03'" type="info">
                                {{item.dicName}}
                            </el-tag>
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='02'" type="danger">
                                {{item.dicName}}
                            </el-tag>
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='01'" type="success">
                                {{item.dicName}}
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号码"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="预定时间段"
                        width="230"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.orderDate}} {{scope.row.weddingBeginTime}}~{{scope.row.weddingEndTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="houseName"
                        label="预定场地"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="commissionMoney"
                        label="提成金额"
                        min-width="180"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="典礼开始时间"
                        width="160"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.beginTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="weddingPackageName"
                        label="预定套餐"
                        width="180"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserName"
                        label="接待人员"
                        width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserPhone"
                        label="接待电话"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="downPayment"
                        label="定 金"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="应收款"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.orderWeddingMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="实收款"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.realPayment||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="退款金额"
                        min-width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.refundMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="差额"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{(scope.row.realPayment||0)-(scope.row.orderMoney||0)-(scope.row.refundMoney||0)}}
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="170"
                        align='center'
                >
                    <template slot-scope="scope">
                        <div style="padding: 5px 0" >
                            <el-button class="ele-btn-small"  type="primary" size="mini" @click="gotoCommission(scope.row.id,scope.row.weddingOrderId,1)"
                            >查看明细
                            </el-button>
                            <el-button class="ele-btn-small" v-if="scope.row.hasCommission==0"  type="primary" size="mini" @click="gotoCommission(scope.row.id,scope.row.weddingOrderId,0)"
                            >提成
                            </el-button>
                            <el-popconfirm
                                    title="是否确定修改提成?"
                                    @confirm="gotoCommission(scope.row.id,scope.row.weddingOrderId,0)"
                                    v-else

                            >
                                <el-button class="ele-btn-small ml-10"  type="primary" size="mini"  slot="reference">修改提成</el-button>
                            </el-popconfirm>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <wed-commission :visible.sync="showCommission" :id="orderId" :wed-id="wedId" :state="editstate"></wed-commission>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import OrderConfirmState from "../../components/data/orderConfirmState";
    import ExtraList from "../component/extra";
    import Payment from "../../components/data/payment";
    import Pagination from "../../components/pagination/pagination";
    import WedCommission from "./sub/WedCommission";

    export default {
        components: {
            WedCommission,
            Pagination,
            Payment,
            ExtraList,
            OrderConfirmState,
            ZTitle
        },
        name: "wedding",
        data() {
            var validatetel = (rule, value, callback) => {
                console.log(value)
                if (!this.$root.mobileformat.test(value) && value) {
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                maleFemaleName: '',
                maleFemalePhone: '',
                orderDate: '',
                dateRange: [],
                orderDateRange:[],
                orderState: "",

                orderId: '',
                wedId: '',

                confirmStateList: [],
                showCommission:false,//结算弹窗
                editstate:0,

                dataList: [],
            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            var date=this.$TM.getDayArea();
            var mm=date.mm,yy=date.yy;
            if(mm==12){
                mm=1;
                yy++;
            }
            var date2=new Date(new Date(this.$TM.getDayArea(yy,mm+1,1).date).getTime()-24*60*60*1000);            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.getWeddingOrder();
        },
        computed: {
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },
        },
        methods: {
            //查询婚庆预定列表
            getWeddingOrder() {
                this.loading = true;
                this.$axios.post('/wedding/findWeddingOrderList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "currentPage": this.currentPage,
                    "pageSize": this.pageSize,
                    "maleFemaleName": this.maleFemaleName,
                    "maleFemalePhone": this.maleFemalePhone,
                    "orderDate": this.orderDate,
                    "orderDateBegin": this.dateRange ? this.dateRange[0] : '',
                    "orderDateEnd": this.dateRange ? this.dateRange[1] : '',
                    "createTimeBegin": this.orderDateRange?this.orderDateRange[0]:'',
                    "createTimeEnd": this.orderDateRange?this.orderDateRange[1]:'',
                    "orderState": '01'
                }).then(res => {
                    console.log('婚庆预定列表', res);
                    this.dataList = res.data.list;
                    this.total = res.data.total;
                    this.getStateList();
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            getStateList() {
                if (this.$root.getStorage('dic')) {
                    this.confirmStateList = this.$root.getStorage('dic').filter((item) => item.dicType == 'order_confirm_state');
                } else {
                    this.$store.state.dicChange = true;;
                }
            },
            //搜索
            searchWeddingOrder() {
                this.currentPage = 1;
                this.getWeddingOrder();
            },


            //显示提成
            gotoCommission(orderId,wedId,idx) {
                this.showCommission=true;
                this.editstate=idx;
                this.wedId = wedId;
                this.orderId = orderId;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getWeddingOrder();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getWeddingOrder();
                console.log(`当前页: ${val}`);
            },

        },

    }
</script>

<style scoped lang="scss">
    .member_bg {
        margin: 0 80px;
        box-shadow: none;
        background: #fefefe;
    }

    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }

    .wedding {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
    }
</style>